module.exports = __webpack_public_path__ + "img/404-illustration.1a6c9134.svg";